import $ from 'jquery'

if (document.getElementById('page-cashless')) {
  $('.Qtext').on('click', function () {
    $(this).siblings('.Atext').slideToggle()
    $(this).toggleClass('active')
  })
}
